// stores/website/configStore.js
import { defineStore } from 'pinia';
import { publicApi } from '../../services/api';
import config from '../../config';  // Asegúrate de importar config para acceder a storageUrl

export const useWebsiteConfigStore = defineStore('websiteConfig', {
  state: () => ({
    config: {
      branding: {
        logo_desktop: null,
        logo_mobile: null,
        logo_navbar: null,
        background: null,
        favicons: {
          default: null,
          16: null,
          32: null,
          192: null,
          512: null
        }
      },
      meta: {
        domain_name: null,
        website_name: null,
        description: null,
        keywords: null,
        tags: null
      },
      social: {
        facebook: null,
        instagram: null,
        tiktok: null,
        whatsapp: null,
        telegram: null
      },
      contact: {
        email: null,
        phone: null
      }
    }
  }),

  // load de webiste type
  actions: {
    async loadConfig() {
      try {
        const response = await publicApi.get('/website-config');
        this.config = response.data.data;
        
        // Actualizar título y favicons después de cargar la configuración
        this.updateDocumentMetadata();
        
        return this.config;
      } catch (error) {
        console.error('Error loading website config:', error);
        throw error;
      }
    },
    
    // Método simple para actualizar el título y los favicons
    updateDocumentMetadata() {
      // Actualizar título de la página
      if (this.config.meta && this.config.meta.website_name) {
        document.title = this.config.meta.website_name;
      }
      
      // Actualizar favicons si están presentes en la configuración
      if (this.config.branding && this.config.branding.favicons) {
        if (this.config.branding.favicons.default) {
          const faviconEl = document.getElementById('favicon-default');
          if (faviconEl) {
            faviconEl.href = `${config.storageUrl}/${this.config.branding.favicons.default}`;
          }
        }
        
        if (this.config.branding.favicons[16]) {
          const favicon16 = document.getElementById('favicon-16');
          if (favicon16) {
            favicon16.href = `${config.storageUrl}/${this.config.branding.favicons[16]}`;
          }
        }
        
        if (this.config.branding.favicons[32]) {
          const favicon32 = document.getElementById('favicon-32');
          if (favicon32) {
            favicon32.href = `${config.storageUrl}/${this.config.branding.favicons[32]}`;
          }
        }
      }
    }
  },

  getters: {
    getLogoUrl: state => type => state.config.branding[`logo_${type}`],
    
    // Añadir getter para favicons si lo necesitas
    getFaviconUrl: state => size => {
      const key = size || 'default';
      if (!state.config.branding?.favicons?.[key]) return null;
      return `${config.storageUrl}/${state.config.branding.favicons[key]}`;
    },

    getBannerUrls: state => device => state.config.news.banners[device],
    getSocialLinks: state => state.config.social,
    getContactInfo: state => state.config.contact
  }
});